<script setup>
import { cn } from '@/lib/utils';
import { ToastDescription } from 'radix-vue';
import { computed } from 'vue';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <ToastDescription :class="cn('text-sm opacity-70', props.class)" v-bind="delegatedProps">
    <slot />
  </ToastDescription>
</template>
